<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :items="domainsItems"
        :headers="headers"
        :loading="loading"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <gg-btn v-bind="attrs" v-on="on">
                Manage
              <v-icon class="ml-1">mdi-chevron-down</v-icon>
            </gg-btn>
            </template>
            <v-list>
              <v-list-item @click="openModal('addRecord', { domain: item.domain, username: item.username, type: 'A' })">
                <v-list-item-title>
                  Add A record
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openModal('addRecord', { domain: item.domain, username: item.username, type: 'CNAME' })">
                <v-list-item-title>
                  Add CNAME record
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openModal('addRecord', { domain: item.domain, username: item.username, type: 'MX' })">
                <v-list-item-title>
                  Add MX record
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="showDetailsTable({ domain: item.domain, username: item.username })">
                <v-list-item-title>
                  Manage Records
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-col>
    <add-record-modal
      v-if="selectedItem"
      :opened="modals.addRecord"
      :domain="selectedItem.domain"
      :username="selectedItem.username"
      :type="selectedItem.type"
      @action-completed="recordAdded"
      @close="closeModal('addRecord')"
    />
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import modalsTable from '@/mixins/modalsTable'
import reloadable from '@/mixins/tableShouldBeReloaded'
import AddRecordModal from './AddRecordModal'

export default {
  name: 'DomainsTable',
  mixins: [reloadable, modalsTable],
  components: {
    AddRecordModal,
  },
  props: {
    search: {
      type: String,
      default: ''
    },
    isResellerOwner: {
      type: Boolean,
      default: false
    },
    isResellerRoute: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      loading: false,
      headers: [
        {
          text: 'Domain',
          value: 'domain'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ],
      modals: {
        addRecord: false,
      }
    }
  },
  computed: {
    ...mapGetters({
      domains_list: 'email/domains_list',
      resellerZones: 'resellerZones',
      resellerSubAccounts: 'resellerSubAccounts',
      hosting: 'hosting',
      hosting_detail: 'hosting_detail',
    }),
    domainsItems () {
      if (this.isResellerOwner && this.isResellerRoute) {
        const mainDomain = { domain: this.hosting?.domain, username: this.hosting_detail?.accountsummary?.owner || '' }

        return this.resellerZones.reduce((carry, zone) => {
          // for reseller zone records we need to find the corresponding subaccount's username
          const correspondingSubAcc = this.resellerSubAccounts.findLast(subAcc => subAcc.domain === zone.domain)
          carry.push({
            domain: zone.domain,
            zonefile: zone.zonefile,
            username: correspondingSubAcc ? correspondingSubAcc.user : ''
          })
          return carry
        }, [mainDomain])
      }

      return this.domains_list.reduce((carry, domains) => {
        // convert array of objects to array of strings
        const domainsStrings = Object.values(domains).reduce((carry, domain) => {
          if (typeof domain === 'string') {
            carry.push(domain)
          } else {
            carry.push(...domain)
          }
          return carry
        }, [])
        carry.push(...domainsStrings)
        return carry
      }, [])
        .map(domain => ({ domain }))
    }
  },
  methods: {
    ...mapActions({
      getDomains: 'email/getDomains',
      fetchResellerZones: 'fetchResellerZones',
      reportError: 'reportError'
    }),
    async reload () {
      const loadRecordsFunc = this.isResellerOwner ? this.fetchResellerZones : this.getDomains

      this.loading = true
      try {
        await loadRecordsFunc(this.$route.query.user)
      } catch (err) {
        this.reportError(err)
      } finally {
        this.loading = false
        this.$emit('domains-table-reloaded')
      }
    },
    showDetailsTable ({ domain, username }) {
      this.$emit('show-details', { domain, username })
    },
    recordAdded (domain) {
      this.showDetailsTable({ domain, username: this.selectedItem.username })
    }
  },
  created () {
    this.reload()
  }
}
</script>
